import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {fetchAlbumList} from "../api/boardManage";
import {AlbumItem} from "../types/board.types";

export const fetchAlbumListAsync = createAsyncThunk(
    'album/fetchAlbumList',
    async () => {
        return await fetchAlbumList();
    }
);

interface albumState {
    albumList: AlbumItem[];
}

const initialState: albumState = {
    albumList: []
};

export const albumSlice = createSlice({
    name: 'album',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAlbumListAsync.pending, () => {
            })
            .addCase(fetchAlbumListAsync.fulfilled, (state, action) => {
                state.albumList = action.payload;
            })
            .addCase(fetchAlbumListAsync.rejected, () => {
            });
    },
});

export default albumSlice.reducer;
